import type { ApiErrorResponse } from './types';

// Utility to normalize token type (capitalize first letter, lowercase the rest)
export function normalizeTokenType(
  tokenType: string | null | undefined,
): string {
  if (!tokenType) return '';

  return tokenType.charAt(0).toUpperCase() + tokenType.slice(1).toLowerCase();
}

export function isApiErrorResponse(data: unknown): data is ApiErrorResponse {
  return (
    typeof data === 'object' &&
    data !== null &&
    'code' in data &&
    'errors' in data &&
    'details' in data
  );
}
